import React, { useState } from "react";
import ProductsNavRow from "../rownavigator";

const GreenTechnology = () => {
    // State
    const [activeSubcategory, setActiveSubcategory] = useState(null);
    const [activeOption, setActiveOption] = useState(null);
    const [activeNestedOption, setActiveNestedOption] = useState(null);
    const [selectedProduct, setSelectedProduct] = useState(null);

    // Data
    const green_technologies = {
        name: "Sustainable Green Building Solutions",
        subcategories: {
            eco_profiles: {
                name: "Eco-Friendly Trim Systems",
                options: {
                    biophilic_design: {
                        name: "Biophilic Design Elements",
                        images: ["/assets/productimages/listels.jpg"],
                        products: [
                            {
                                name: "Recycled PU Architectural Molding",
                                image: "/assets/productimages/listels.jpg",
                                use: "Sustainable architectural detailing",
                                details: "2m length, 100% recycled polyurethane",
                                price: "",
                            },
                        ],
                    },
                    protective_solutions: {
                        name: "Sustainable Protection",
                        images: ["/assets/productimages/cornerprotection.jpg"],
                        products: [
                            {
                                name: "Recycled Aluminum Corner Guard",
                                image: "/assets/productimages/cornerprotection.jpg",
                                use: "Eco-conscious surface protection",
                                details: "3m length, 80% post-consumer aluminum",
                                price: "",
                            },
                        ],
                    },
                    green_transitions: {
                        name: "Sustainable Transition Solutions",
                        options: {
                            wall_base: {
                                name: "Eco Wall Bases",
                                images: ["/assets/productimages/skirting.webp"],
                                products: [
                                    {
                                        name: "FSC-Certified Wood Skirting",
                                        image: "/assets/productimages/skirting.webp",
                                        use: "Sustainable wall-floor transitions",
                                        details: "70mm height, sustainably harvested pine",
                                        price: "",
                                    },
                                ],
                            },
                            floor_transitions: {
                                name: "Green Floor Transitions",
                                images: ["/assets/productimages/flooroperation.jpeg"],
                                products: [
                                    {
                                        name: "Recycled Aluminum Transition Strip",
                                        image: "/assets/productimages/flooroperation.jpeg",
                                        use: "Low-impact floor transitions",
                                        details: "100% recycled aluminum, 2m length",
                                        price: "",
                                    },
                                ],
                            },
                            stair_safety: {
                                name: "Eco Stair Solutions",
                                images: ["/assets/productimages/storenosing.jpeg"],
                                products: [
                                    {
                                        name: "Sustainable Anti-Slip Nosing",
                                        image: "/assets/productimages/storenosing.jpeg",
                                        use: "Green stair safety",
                                        details: "Recycled aluminum with recycled rubber insert",
                                        price: "",
                                    },
                                ],
                            },
                        },
                    },
                },
            },
            sustainable_joints: {
                name: "Eco-Conscious Joint Systems",
                options: {
                    thermal_movement: {
                        name: "Thermal Expansion Solutions",
                        images: ["/assets/productimages/extensionjoins.jpeg"],
                        products: [
                            {
                                name: "Recycled Aluminum Expansion Joint",
                                image: "/assets/productimages/extensionjoins.jpeg",
                                use: "Sustainable movement solutions",
                                details: "20mm width, 90% recycled content",
                                price: "",
                            },
                        ],
                    },
                    green_structural: {
                        name: "Sustainable Structural Joints",
                        images: ["/assets/productimages/buildingjoins.jpeg"],
                        products: [
                            {
                                name: "Bio-Based Construction Joint",
                                image: "/assets/productimages/buildingjoins.jpeg",
                                use: "Eco-friendly building connections",
                                details: "Plant-based PVC alternative",
                                price: "",
                            },
                        ],
                    },
                    fire_resilience: {
                        name: "Sustainable Fire Barriers",
                        images: ["/assets/productimages/firebarrier.jpeg"],
                        products: [
                            {
                                name: "Eco Fire-Rated Joint System",
                                image: "/assets/productimages/firebarrier.jpeg",
                                use: "Green fire protection",
                                details: "2-hour fire rating, non-toxic materials",
                                price: "",
                            },
                        ],
                    },
                    dynamic_systems: {
                        name: "Sustainable Movement Solutions",
                        images: ["/assets/productimages/retractingjoints.jpeg"],
                        products: [
                            {
                                name: "Recycled Content Seismic Cover",
                                image: "/assets/productimages/retractingjoints.jpeg",
                                use: "Eco structural movement",
                                details: "50mm capacity, 85% recycled materials",
                                price: "",
                            },
                        ],
                    },
                },
            },
        },
    };


    // Handlers
    const handleSubcategoryClick = (key) => {
        setActiveSubcategory(key);
        setActiveOption(null);
        setActiveNestedOption(null);
    };

    const handleOptionClick = (key) => {
        setActiveOption(key);
        setActiveNestedOption(null);
    };

    const handleNestedOptionClick = (key) => {
        setActiveNestedOption(key);
    };

    const handleProductClick = (product) => {
        setSelectedProduct(product);
    };

    const closeModal = () => setSelectedProduct(null);

    // Render
    const renderSubcategories = () => (
        <div className="mb-3">
            <h2 className="text-lg font-semibold mb-3">Subcategories</h2>
            <div className="flex flex-wrap gap-2">
                {Object.entries(green_technologies.subcategories).map(([key, sub]) => (
                    <button
                        key={key}
                        onClick={() => handleSubcategoryClick(key)}
                        className={`px-3 py-1 rounded-full text-sm ${activeSubcategory === key
                            ? "bg-blue-500 text-white"
                            : "bg-gray-200 text-gray-700 hover:bg-gray-300"
                            }`}
                    >
                        {sub.name}
                    </button>
                ))}
            </div>
        </div>
    );

    const renderOptions = () => {
        if (!activeSubcategory) return null;
        const sub = green_technologies.subcategories[activeSubcategory];
        if (!sub.options) return null;

        return (
            <div className="mb-3">
                <h2 className="text-lg font-semibold mb-3">Options</h2>
                <div className="flex flex-wrap gap-2">
                    {Object.entries(sub.options).map(([key, opt]) => (
                        <button
                            key={key}
                            onClick={() => handleOptionClick(key)}
                            className={`px-3 py-1 rounded-full text-sm ${activeOption === key
                                ? "bg-green-500 text-white"
                                : "bg-gray-200 text-gray-700 hover:bg-gray-300"
                                }`}
                        >
                            {opt.name}
                        </button>
                    ))}
                </div>
            </div>
        );
    };

    const renderNestedOptions = () => {
        if (!activeSubcategory || !activeOption) return null;
        const opt =
            green_technologies.subcategories[activeSubcategory].options[activeOption];
        if (!opt.options) return null;

        return (
            <div className="mb-3">
                <h2 className="text-lg font-semibold mb-3">More Options</h2>
                <div className="flex flex-wrap gap-2">
                    {Object.entries(opt.options).map(([key, nested]) => (
                        <button
                            key={key}
                            onClick={() => handleNestedOptionClick(key)}
                            className={`px-3 py-1 rounded-full text-sm ${activeNestedOption === key
                                ? "bg-purple-500 text-white"
                                : "bg-gray-200 text-gray-700 hover:bg-gray-300"
                                }`}
                        >
                            {nested.name}
                        </button>
                    ))}
                </div>
            </div>
        );
    };

    const renderProducts = () => {
        let products = [];

        if (activeSubcategory && activeOption && activeNestedOption) {
            products =
                green_technologies.subcategories[activeSubcategory].options[activeOption]
                    .options[activeNestedOption].products || [];
        } else if (activeSubcategory && activeOption) {
            products =
                green_technologies.subcategories[activeSubcategory].options[activeOption]
                    .products || [];
        } else if (activeSubcategory) {
            products =
                green_technologies.subcategories[activeSubcategory].products || [];
        }

        if (!products.length) {
            return (
                <div className="text-center py-10 text-gray-500">
                    No products available
                </div>
            );
        }

        return (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {products.map((p, idx) => (
                    <div
                        key={idx}
                        className="border rounded-lg shadow hover:shadow-lg cursor-pointer"
                        onClick={() => handleProductClick(p)}
                    >
                        <img
                            src={p.image}
                            alt={p.name}
                            className="w-full h-48 object-cover"
                        />
                        <div className="p-4">
                            <h3 className="font-semibold text-lg">{p.name}</h3>
                            <p className="text-gray-600">{p.use}</p>
                            <p className="text-blue-600 font-bold">{p.price}</p>
                        </div>
                    </div>
                ))}
            </div>
        );
    };

    const renderModal = () =>
        selectedProduct && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
                <div className="bg-white rounded-lg max-w-lg w-full overflow-hidden">
                    <div className="flex justify-between items-center p-4 border-b">
                        <h2 className="text-xl font-bold">{selectedProduct.name}</h2>
                        <button onClick={closeModal}>&times;</button>
                    </div>
                    <img
                        src={selectedProduct.image}
                        alt={selectedProduct.name}
                        className="w-full h-64 object-cover"
                    />
                    <div className="p-4 space-y-2">
                        <p>
                            <strong>Uses:</strong> {selectedProduct.use}
                        </p>
                        <p>
                            <strong>Details:</strong> {selectedProduct.details}
                        </p>

                    </div>
                    <div className="p-4 flex justify-end border-t">
                        <button
                            onClick={closeModal}
                            className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        );

    return (
        <>
            <ProductsNavRow />
            <div className="container mx-auto px-4 py-2">
                <h1 className="text-3xl font-bold mb-3">{green_technologies.name}</h1>
                {renderSubcategories()}
                {renderOptions()}
                {renderNestedOptions()}
                {renderProducts()}
                {renderModal()}
            </div>
        </>
    );
};

export default GreenTechnology;
